module.exports = __webpack_public_path__ + "static/openhxouse-3508e7b8f2fc976b42ef07e9aee691f8.jpg";